
import { defineComponent } from 'vue'
import { formatDate } from '@/helpers/commons/localeHelper'
import { iInputVariable } from '../../../../FunctionsCatalog'
import Calendar from 'primevue/calendar'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import functionsCatalogDatasetFormVariablesTableDescriptor from './FunctionsCatalogDatasetFormVariablesTableDescriptor.json'

export default defineComponent({
    name: 'function-catalog-dateset-form-variables-table',
    components: { Calendar, Column, DataTable },
    props: { variables: { type: Array } },
    data() {
        return { functionsCatalogDatasetFormVariablesTableDescriptor, inputVariables: [] as iInputVariable[] }
    },
    watch: {
        propinputColumns() {
            this.loadinputColumns()
        }
    },
    created() {
        this.loadinputColumns()
    },
    methods: {
        loadinputColumns() {
            this.inputVariables = this.variables as iInputVariable[]
        },
        getIconClass(type: string) {
            switch (type) {
                case 'NUMBER':
                    return 'fa fa-hashtag'
                case 'STRING':
                    return 'fa fa-quote-right'
                case 'DATE':
                    return 'fa fa-calendar'
                default:
                    return ''
            }
        },
        getFormatedDate(date: any) {
            return formatDate(date, 'MM/DD/YYYY')
        },
        onCellEditComplete(event: any) {
            this.inputVariables[event.index] = event.newData
        }
    }
})
